// extracted by mini-css-extract-plugin
export default {"container":"add_idea_modal_container__ClwZA","areas_container":"add_idea_modal_areas_container__XmpwJ"};